import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCheck,FiClock,FiShield,FiZap,FiGift}=FiIcons;

const Hero=({timeLeft,formatTime,openCheckoutPopup})=> {
  return (
    <section className="pt-24 pb-16 bg-gradient-to-br from-purple-50 via-white to-orange-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{opacity: 0, x: -50}}
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8}}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 leading-tight mb-6">
              <span className="gradient-text">Struggling to Get Sales?</span>
              <br />
              Learn 24 Ways to Fix It and{' '}
              <span className="text-orange-500">Double Your Income</span>
              This Diwali! 🪔
            </h1>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Grab the ultimate <strong className="text-purple-600">₹97 Diwali eBook</strong> packed with 24 practical growth hacks, free automation tools, and a bonus workshop to help you double your leads, automate follow-ups, and boost sales before the festive season ends.
            </p>
            
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-green-500 w-5 h-5" />
                <span className="text-gray-700">24+ proven tactics to 2X your income</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiGift} className="text-orange-500 w-5 h-5" />
                <span className="text-gray-700">Diwali-special workshop + bonus tools</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiZap} className="text-blue-500 w-5 h-5" />
                <span className="text-gray-700">WhatsApp + Email automation templates</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-green-500 w-5 h-5" />
                <span className="text-gray-700">Works for all business owners & professionals</span>
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-lg border-2 border-orange-200 mb-8">
              <div className="text-center">
                <div className="flex items-center justify-center space-x-4 mb-4">
                  <div className="text-gray-500 line-through text-xl">Regular Price: ₹997</div>
                  <div className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    90% OFF
                  </div>
                </div>
                <div className="text-4xl font-bold gradient-text mb-2">
                  Diwali Offer: Only ₹97 Today
                </div>
                <div className="text-orange-600 font-semibold mb-4">
                  Limited Offer – First 15 Minutes Only!
                </div>
                <div className="timer-glow text-white px-6 py-3 rounded-xl inline-flex items-center space-x-2 mb-4">
                  <SafeIcon icon={FiClock} className="w-5 h-5" />
                  <span className="font-bold text-xl">{formatTime(timeLeft)}</span>
                </div>
                <p className="text-sm text-gray-600">⏰ Grab your bonuses before the timer ends!</p>
              </div>
            </div>

            <button 
              onClick={openCheckoutPopup}
              className="glow-button text-white px-8 py-4 rounded-xl font-bold text-lg w-full md:w-auto mb-6 flex items-center justify-center space-x-2"
            >
              <span>🎇</span>
              <span>Get Instant Access for ₹97</span>
              <span>→</span>
            </button>

            <div className="flex items-center justify-center md:justify-start space-x-8 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiShield} className="text-green-500 w-4 h-4" />
                <span>Secure Payment</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiZap} className="text-blue-500 w-4 h-4" />
                <span>Instant Download</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiGift} className="text-orange-500 w-4 h-4" />
                <span>Bonuses Included</span>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="relative"
            initial={{opacity: 0, x: 50}}
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0.2}}
          >
            <div className="relative floating">
              <div className="diya-glow bg-gradient-to-br from-purple-600 to-orange-400 p-8 rounded-3xl">
                <div className="bg-white p-6 rounded-2xl shadow-2xl">
                  <div className="text-center">
                    <div className="text-6xl mb-4">📚</div>
                    <h3 className="font-bold text-2xl text-gray-800 mb-2">
                      24 Ways to Double Your Sales
                    </h3>
                    <p className="text-gray-600 mb-4">
                      Complete Diwali Success Guide
                    </p>
                    <div className="flex items-center justify-center space-x-2 text-yellow-500">
                      {[...Array(5)].map((_, i)=> (
                        <span key={i}>⭐</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 bg-orange-400 text-white p-3 rounded-full animate-bounce">
                🎁
              </div>
              <div className="absolute -bottom-4 -left-4 bg-purple-600 text-white p-3 rounded-full animate-pulse">
                💰
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;